import $ from 'swiper/esm/utils/dom';
import {scrollTop, scrollTo} from 'dom7';

$.fn['scrollTop'] = scrollTop;
$.fn['scrollTo'] = scrollTo;

let common = require('./modules/common');

common.init();

let internals = {
    newsSlider: null,
    initNewsSlider: function (Swiper) {
        internals.newsSlider = new Swiper('#slider_news', {
            autoplay: false,
            loop: false,
            slidesPerView: 1.15,
            spaceBetween: 15,
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1200: {
                    spaceBetween: 15,
                    slidesPerView: 3,
                }
            },

        });
    },
    initVideo: function () {
        internals.observeCallback('ytplayer_1', function () {
            window['onYouTubePlayerAPIReady'] = function () {
                document.querySelectorAll('.video-player').forEach(
                    function (el) {
                        new YT.Player(el.id, {
                            height: '390',
                            width: '640',
                            playerVars: {
                                autoplay: 0,
                                rel: 0
                            },
                            videoId: el.getAttribute('data-code'),
                            origin: 'https://raisa.blog'
                        });
                    }
                );
            };

            let s = document.createElement('script');
            s.src = 'https://www.youtube.com/player_api';
            s.async = true;
            s.defer = true;
            document.body.appendChild(s);
        });
    },
    observeCallback: function (element, callback) {
        if (!('IntersectionObserver' in window)) {
            callback();
        } else {
            let observer = new IntersectionObserver(function (entries, observer) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        callback();
                        observer.disconnect();
                    }
                });
            }, {
                rootMargin: '10px 0px',
                threshold: 0.01
            });
            observer.observe(document.getElementById(element));
        }
    }
};

import(
    /* webpackChunkName: "swiper" */
    './modules/swiper').then(function (module) {
    internals.initNewsSlider(module.default);
}, function (e) {
    throw new Error('Unable to load swiper library: ' + e.message);
});

internals.initVideo();